import React, { useCallback } from 'react';
import { useApiCall } from '../utils/hooks';
import usePagedQuery from './usePagedQuery';

/**
 * Layout for list pages (Vulnerabilities, Packages, Hosts): PageHeader, FilterBar
 * and a DataTable with className="flex-1" inside; only the table scrolls.
 */
export default function ListPage({ children }) {
  return <div className="h-full flex flex-col overflow-hidden px-6 pt-5 pb-5">{children}</div>;
}

/**
 * usePagedQuery for a list page. Requests go through executeQuery, so first pages
 * show the global loading indicator and the slow-query warning; later pages don't.
 * fetchPage({ offset, limit }) must change only with key.
 */
export function useListQuery(fetchPage, key, name) {
  const { executeQuery } = useApiCall();
  const tracked = useCallback(
    (paging) => executeQuery(() => fetchPage(paging), `${name}_${key}_${paging.offset}_${paging.limit}`, { isPagination: paging.offset > 0 }),
    [fetchPage, executeQuery, key, name],
  );
  return usePagedQuery(tracked, key);
}
